export class DegreeMapInstructioncComponentStateModel {
  public componentExpanded: boolean = false;
}

angular
  .module('capability-ng-academic-planner')
  .service('ngDegreeMapInstructioncComponentStateModel', DegreeMapInstructioncComponentStateModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/degree_map/components/degree_map_instructions_component/models/degree_map_instructions_component_state_model.ts